import React, { useState } from "react";
import styleSheet from "./style.module.scss";
import SyIcon from "../../../../shared/components/sy-icon";
import { useTranslation } from "react-i18next";
import SyPopup from "../../../../shared/components/sy-model";
import OrbConfirmation from "../../../../shared/components/orb-confirmation";
import { btnConfig } from "./config";
import OrbAvatar from "../../../../shared/components/orb-avatar";

type Props = {};

function CitizensList(prop: any) {
  const {citizensData,deleteCitizen} = prop
    const { t } = useTranslation();
  const [openConfirmPopup, setConfirmPopup] = useState<any>(false);
  const [deletedData, setDeletedData] = useState<any>(null);

    const clickConfirm =(data:any)=>{
      setConfirmPopup(true);
      setDeletedData(data)
    }
    const onCloseConfirmPop = () => {
      setConfirmPopup(false);
    };

    const onConfirmClick = (val: any) => {
      setConfirmPopup(false);
      if (val) {
        deleteCitizen(deletedData)
      } 

    };
    
  const getTableRow = (data: any) =>
    data?.map((data: any, index: number) => (
      <tr key={index} className="lh-lg ">
        <td className={`small-font ellipsis ps-2`}> <OrbAvatar file={data.usr_img} className={styleSheet.avatar} /></td>
        <td className={`small-font ellipsis`}>{data.usr_name}</td>
        <td className={`small-font ellipsis`}>{data.by_name}</td>
        <td className={`small-font ellipsis`}>
          <SyIcon name="delete" className={"top-50 sub-font d-flex justify-content-center align-self-center pointer" } iconStyle="outlined" iconType="symbols"  onClick={()=>clickConfirm(data)}/>
        </td>
      </tr>
    ));

  return (
    <>
       <SyPopup
          open={openConfirmPopup}
          onClose={onCloseConfirmPop}
          maxWidth={"xs"}
        >
          <OrbConfirmation
            message={"are_you_sure_to_proceed_with_this_action"}
            onConfirmClick={onConfirmClick}
              buttons={btnConfig}
          />
        </SyPopup>
    

    <table className={` ${styleSheet.table_style} w-100`}>
      <thead className="lh-lg">
        <tr>
          <th className="sub-font   ps-2 col-2 ellipsis" scope="col">
            {t("person")}
          </th>
          <th className="sub-font col-4 ellipsis" scope="col">
          {t("citizens")}
          </th>
          
          <th className="sub-font col-4 ellipsis" scope="col">
          {t("invite_by")}
          </th>
          <th className="sub-font col-2 ellipsis" scope="col">
          {t("action")}
          </th>
        </tr>
      </thead>
      <tbody>{getTableRow(citizensData)}</tbody>
      {!citizensData.length && (
          <div className=" position-absolute top-50 start-50 translate-middle  mohave text-white  ">
            <p className="">{t("no_data_found")}</p>
          </div>
        )}
    </table>
    </>
  );
}

export default CitizensList;
